import { styled } from '@stitches/configed';
import Avatar from '../Common/Avatar';
import Menu, { Item as MenuItem } from 'rc-menu';
import Dropdown from '../Common/Dropdown';
import PersonalOutlinedIcon from '../Common/Icons/PersonalOutlinedIcon';
import LogoutIcon from '../Common/Icons/LogoutIcon';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UserInfo = styled('div', {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',

  '&>.name': {
    marginLeft: 16,
    marginRight: 0,
  },
  variants: {
    direction: {
      rtl: {
        direction: 'rtl',
        '&>.name': {
          marginLeft: 0,
          marginRight: 23,
        },
      },
    },
  },
});

const Name = styled('div', {
  '.title': {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: '-2px',
  },
  '.sub': {
    marginTop: 6,
    fontSize: 12,
    fontWeight: 300,
    color: '#4E5A73',
    '@lg': {
      color: '$text2',
    },
  },
});

export const StoreInfo = styled('div', {
  cursor: 'pointer',
  background: '#FAFBFF33',
  borderRadius: 6,
  padding: 12,
  margin: '16px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
  svg: {
    marginLeft: 16,
  },
});
const MenuItemContent = styled('div', {
  display: 'flex',
  cursor: 'pointer',
  svg: {
    marginRight: 16,
    fontSize: 22,
    '&.profile': {
      color: '$brand',
    },
    '&.danger': {
      color: '$danger',
    },
  },
  span: {
    fontWeight: 600,
  },
});

export type Profile = {
  id: number;
  fullname: string;
  phoneNumber: string;
  email: string;
  gender: number;
  avatar: string;
  availability: boolean;
  token: string;
};
type Props = {
  direction?: 'rtl';
  hideProfileOption?: boolean;
};
const UserBlock = ({ direction, hideProfileOption }: Props) => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>();
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      // console.log(JSON.parse(user));
      setUser(JSON.parse(user));
    }
  }, []);

  const menu = (
    <Menu>
      {!hideProfileOption && (
        <MenuItem key="info" onClick={() => navigate('/profile')}>
          <MenuItemContent>
            <PersonalOutlinedIcon className="profile" />
            <span>Hồ sơ</span>
          </MenuItemContent>
        </MenuItem>
      )}
      <MenuItem key="logout" onClick={() => navigate('/logout')}>
        <MenuItemContent>
          <LogoutIcon className="danger" />
          <span>Đăng xuất</span>
        </MenuItemContent>
      </MenuItem>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger="click">
      <UserInfo direction={direction}>
        <Avatar src={user?.avatar} />
      </UserInfo>
    </Dropdown>
  );
};

export default UserBlock;
